
(function () {
    angular.module('pages.home', [
        'components.loader',
        'components.pagination',      
        'components.calendar',
        'services.global',
        'ngCookies'
    ])
        .controller('homeController', homeController);

    /**
     * @ngdoc controller
     * @name pages.homeController
     * @requires components.pagination
     * @description
     * Controller used for the blog and blog detail templates.
     */
    homeController.$inject = ['$scope', '$window', '$cookies'];
    function homeController($scope, $window, $cookies) {
        var ctrl = this;
        var banner = angular.element('.banner');

        var videoBackground = banner.find('.video-background');
        if (videoBackground.length) {
            videoBackground.YTPlayer({
                fitToBackground: true,
                videoId: videoBackground.attr('video-id')
            })
        }

        ctrl.$onInit = function () {
            ctrl.$win = angular.element($window).on('resize.home', ctrl.sizeBanner); 
        }

        ctrl.$onDestroy = function () {
            ctrl.$win.off('resize.home');
        }
        var panels = angular.element('[data-tabs-content="home-sections"] > div');
        if (panels.filter('.is-active').length > 1) {
            angular.element(panels[0]).removeClass('is-active');
        }
        else {
            var tabControls = angular.element('#home-sections').on('change.zf.tabs', function () {
                angular.element(panels[0]).removeClass('is-active');
                tabControls.off('change.zf.tabs');
            });
        }

        var alert = angular.element('.reveal.is-alert');
        if (alert.length) {
            console.log(alert.attr("last-update"));
            var alertTime = parseInt(alert.attr('last-update'));
            var alertViewed = $cookies.get('alert-viewed');
            console.log(alertViewed, alertTime);
            if (!alertViewed || alertViewed < alertTime) {
                alert.foundation('open');
                $cookies.put('alert-viewed', alertTime);
            }
        }        
    }
})();